import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useAuthenticator } from '@aws-amplify/ui-react';
import AuthLegalFooter from '@/components/auth/AuthLegalFooter';
import { SOCIAL_LOGIN_ENABLED } from '@/config/cognito';

export function AuthEmptyHeader(): null {
  return null;
}

export function AuthFormWordmark(): React.ReactElement {
  return (
    <span className="auth-form-wordmark">
      We<span className="auth-form-wordmark__accent">Tree</span>
    </span>
  );
}

function AuthMethodHint(): React.ReactElement | null {
  const { t } = useTranslation('auth');
  if (!SOCIAL_LOGIN_ENABLED) return null;
  return <p className="auth-method-hint">{t('methodHint')}</p>;
}

export function SignInHeading(): React.ReactElement {
  return (
    <>
      <h3 className="amplify-heading">
        <Trans i18nKey="signIn.formHeading" ns="auth" components={{ brand: <AuthFormWordmark /> }} />
      </h3>
      <AuthMethodHint />
    </>
  );
}

export function SignUpHeading(): React.ReactElement {
  return (
    <>
      <h3 className="amplify-heading">
        <Trans i18nKey="signUp.formHeading" ns="auth" components={{ brand: <AuthFormWordmark /> }} />
      </h3>
      <AuthMethodHint />
    </>
  );
}

export function ResetPasswordHeading(): React.ReactElement {
  return (
    <h3 className="amplify-heading">
      <Trans i18nKey="forgotPassword.formHeading" ns="auth" components={{ brand: <AuthFormWordmark /> }} />
    </h3>
  );
}

export function ConfirmSignUpHeading(): React.ReactElement {
  const { t } = useTranslation('auth');
  return (
    <>
      <h3 className="amplify-heading">{t('confirmSignUp.formHeading')}</h3>
      <h4 className="amplify-authenticator__subtitle amplify-heading--4">{t('confirmSignUp.formSubheading')}</h4>
    </>
  );
}

export function ConfirmResetPasswordHeading(): React.ReactElement {
  const { t } = useTranslation('auth');
  return <h3 className="amplify-heading">{t('confirmResetPassword.formHeading')}</h3>;
}

export function AuthBackToSignInFooter(): React.ReactElement {
  const { t } = useTranslation('auth');
  const { toSignIn } = useAuthenticator((context) => [context.toSignIn]);

  return (
    <div data-amplify-footer="">
      <button type="button" className="amplify-button amplify-button--link auth-back-link" onClick={toSignIn}>
        {t('backToSignIn')}
      </button>
    </div>
  );
}

export function AuthSignInFooter(): React.ReactElement {
  const { t } = useTranslation('auth');
  const { toForgotPassword, route } = useAuthenticator((context) => [context.toForgotPassword, context.route]);
  const showForgotPassword = route === 'signIn';

  return (
    <div data-amplify-footer="">
      {showForgotPassword ? (
        <button
          type="button"
          className="amplify-button amplify-button--link auth-forgot-password-link"
          onClick={toForgotPassword}
        >
          {t('forgotPasswordLink')}
        </button>
      ) : null}
      <AuthLegalFooter />
    </div>
  );
}
